import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAssetsState, IBrandElementsState } from '../../interfaces/state.interfaces';
import { IUploadedAsset } from '../../interfaces/assets.interface';
import { IDesignElements, IDesignElementsFonts } from '../../interfaces/brand-magic.interface';

const initialState: IBrandElementsState = {
    designElements: null,
};

const brandElementsSlice = createSlice({
    name: 'brandElements',
    initialState,
    reducers: {
        SetDesignElements(state, action: PayloadAction<IDesignElements>) {
            state.designElements = action.payload;
        },
        SetDesignElementsFonts(state, action: PayloadAction<IDesignElementsFonts>) {
            if (state.designElements) {
                state.designElements.fonts = action.payload;
            }
        },
        SetDesignElementsColors(state, action: PayloadAction<string[]>) {
            if (state.designElements) {
                state.designElements.colors = action.payload;
            }
        },
        SetDesignElementsLogo(state, action: PayloadAction<string | null>) {
            if (state.designElements) {
                state.designElements.logo = action.payload;
            }
        },
        SetBrandElementsInitialState(state) {
            state.designElements = null;
        },
    },
});

export const {
    SetDesignElements,
    SetDesignElementsFonts,
    SetDesignElementsLogo,
    SetDesignElementsColors,
    SetBrandElementsInitialState,
} = brandElementsSlice.actions;

export const brandElementsReducer = brandElementsSlice.reducer;
